'use strict';
import moment from 'moment'
import * as scoreHierarchy from '../scores/scoreHierarchy'
import {entityIdStringToStructuredEntityId, toEntityId} from "../../services/locations/entityIdConversions";
import FeaturesStore from '../../modules/app/FeaturesStore'

angular.module('clientDashboardApp').controller("SnapshotCtrl",
  function ($scope, $timeout, $log, $state, $location, $filter, $http, searchService,
            locationService, reviewService, listingService, rankingService,
            scoreService, snapshotService, configService, userService,
            localSearchAnalyticsService,
            scoreResultsService) {
    $scope.$state = $state;
    $scope.locationSummaries = {};
    $scope.locationInfo = {
      newlocation: false
    };
    $scope.summaryDate = undefined;
    $scope.datePickerOptions = {
      format: "MMMM yyyy",
      startingDay: 1,
      maxDate: new Date(),
      minMode: 'month'
    };

    $scope.tooltips = {
      score: "The LBV (Local Brand Visibility) Score is an aggregate of the most important performance metrics tied to reputation (Reviews), social media activity (Social), and local search (Listings and Rankings). Customer activity levels, listing accuracy, rankings, customer ratings, and your competitors all factor into the score. In general, a score above 70 is reflective of an industry leader, a score between 30 and 70 is average, and a score below 30 is poor."
    }

    $scope.workflowLink = function(hideWorkflow) {
      if (hideWorkflow || ($scope.user && $scope.user.permissions.indexOf('ShowWorkflow') === -1)) {
        return ""
      }
      else {
        return "#/workflow/scoring"
      }
    }

    /**
     * Opens a report for the a location.
     * @param defaultSummaryReportId
     * @param summaryLocationId
     * @param summaryDate
       */
    $scope.applySummaryDateChange = function (defaultSummaryReportId, summaryLocationId, summaryDate) {
      var y = summaryDate.getFullYear(), m = summaryDate.getMonth();
      var firstDay = formatReportDate(new Date(y, m, 1));
      var lastDay = formatReportDate(new Date(y, m + 1, 0));

      var url = "/v5/reports/" + defaultSummaryReportId + "/" + summaryLocationId +"/generate?start=" + firstDay + "&end=" + lastDay + "&accountId="+$scope.userInfo.accountId;
      var reportTab = window.open(url, '_blank');
      reportTab.focus();
    };

    var prepareReports = function (groupId) {
      const {entityType, id} = entityIdStringToStructuredEntityId(toEntityId(groupId))

      $scope.summaryEnabled = entityType === 'Location'
      //Get location info for start date
      if ($scope.summaryEnabled) {

        locationService.getLocation(id)
          .then(populateReportBox)
          .then(function (location) {
            $scope.datePickerEnabled = false;
            if (angular.isUndefined(location.dateAdded)) return location;
            if ($scope.summaryReports.length < 4)  return location;
            $scope.datePickerOptions.minDate = new Date(location.dateAdded);
            $scope.datePickerEnabled = true;
            $scope.summartMinDate = new Date(location.dateAdded);
          });
      } else {
        $scope.summaryMessage = "Select a single location to see summary reports.";
      }
    };

    var populateReportBox = function (location) {
      $scope.summaryReports = [];
      if (angular.isUndefined(location.dateAdded)) {
        $scope.summaryMessage = "Unable to generate reports for this location";
        return location;
      }

      var locationStartDate = new Date(location.dateAdded);
      $scope.summaryReports = buildSummaryReportRange(locationStartDate);

      if (!$scope.summaryReports.length) {
        $scope.summaryMessage = "Not enough data to generate historic reports.";
        return;
      }
      $scope.summaryLocationId = location.locationId;
      return location
    };

    function formatReportDate(date) {
      return $filter('date')(date, 'yyyy-MM-dd');
    }

    var buildSummaryReportRange = function (locationStartDate) {
      var summaryDates = [];

      var date = new Date();
      for (var i = 0; i <= 3; i++) {
        var startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        var endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        if (locationStartDate > endOfMonth) {
          continue;
        }

        summaryDates.push({
          dateStart: formatReportDate(startOfMonth),
          dateEnd: formatReportDate(endOfMonth),
          monthName: getMonthName(startOfMonth.getMonth())
        });

        date.setDate(-1);
      }

      if (locationStartDate >= startOfMonth && locationStartDate <= endOfMonth) {
        $scope.locationInfo.newlocation = true;
      }
      else {
        $scope.locationInfo.newlocation = false;
      }

      return summaryDates;
    };

    var getMonthName = function (monthNumber) {
      var month = [];
      month[0] = "January";
      month[1] = "February";
      month[2] = "March";
      month[3] = "April";
      month[4] = "May";
      month[5] = "June";
      month[6] = "July";
      month[7] = "August";
      month[8] = "September";
      month[9] = "October";
      month[10] = "November";
      month[11] = "December";

      return month[monthNumber];
    };

    $scope.uniqueSyndReviews = function (reviews) {
      var unique = _.uniq(reviews, function (item) {
        return item.contentProvider;
      });
      return unique;
    };

    const whenBrandConfigAndUser = Promise
      .all([configService.getBrandConfig(), userService.currentUser()])
      .then(([brandConfig, user]) => {
        $scope.brandConfig = brandConfig;
        $scope.user = user;
        return { brandConfig, user }
      });

    $scope.isTabEnabled = tabRoute => {
      return FeaturesStore.routeEnabled(tabRoute)
    }


    function loadSnapshot(groupId) {

      $scope.groupId = groupId

      whenBrandConfigAndUser.then(() => {
        $scope.scoreSummary = null;

        prepareReports(groupId);

        const reportStartDate = moment().subtract(30, 'days').format("YYYY-MM-DD");
        $scope.reportStartDate = reportStartDate;

        const scorePaths = scoreHierarchy.withDescendants('total', 2);
        $scope.scores = scorePaths.reduce((sum, path) => ({...sum, [path]: { scorePath: path }}));

        /**
         * Trigger the LBV Summary first in the list of promises to limit the wait time on the response.
         */
        // LBV Summary
        scoreResultsService.overallChange({
          groupId,
          start: moment().subtract(30, 'days').toDate(),
          end: moment().toDate(),
          scorePaths,
        }).then(data => {
          $scope.scores = data.values.reduce((sum, value) => {
            return {
              ...sum,
              [value.scorePath]: value
            }
          }, {})
        });

        // Score Summary
        scoreService.snapshotSummary(groupId).then(
          function (scoreSummary) {
            $scope.scoreSummary = {};
            $scope.scoreSummary.imageFilename = 5 * Math.round(scoreSummary.averageScore / 5);
            $scope.scoreSummary.roundedOverallScore = Math.round(scoreSummary.averageScore);
          }
        );

        // Review Summary
        reviewService.snapshotSummary(groupId).then(
          function (reviewSummary) {
            $scope.reviewsSummary = reviewSummary;
          }
        );

        // Listings Summary
        listingService.snapshotSummary(groupId).then(
          function (listingsSummary) {
            $scope.listingsSummary = listingsSummary;
          }
        );

        // Ranking Summary
        rankingService.snapshotSummary(groupId).then(
          function (rankingSummary) {
            $scope.rankingSummary = rankingSummary;
          }
        );

        // Search Analytics Summary
        localSearchAnalyticsService.snapshotSummary(groupId, reportStartDate)
          .then(resp => resp.data)
          .then(searchAnalyticsSummary => {
            $scope.searchAnalyticsSummary = {
              actionsHistory: [searchAnalyticsSummary.combinedActionsStats.total, searchAnalyticsSummary.combinedActionsStats.previousTotal],
              impressionsHistory: [searchAnalyticsSummary.combinedSearchAppearancesStats.total, searchAnalyticsSummary.combinedSearchAppearancesStats.previousTotal],
            }
          });

        // Snapshot Report
        snapshotService.snapshotReport(groupId).then(
          function (snapshotReport) {
            $scope.defaultSummaryReportId = snapshotReport.defaultSummaryReportId;
            $scope.last3NegativeReviews = snapshotReport.last3NegativeReviews;
            $scope.last3PositiveReviews = snapshotReport.last3PositiveReviews;
          }
        );

      })
    }

    if (locationService.getSelectedGroupId() !== $state.params.groupId && $state.params.groupId) {
      locationService.setSelectedGroupId($state.params.groupId);    // Known issue with this: due to the watcher, manually tweaking the group ID in the url
      $state.go('snapshot', {groupId: $state.params.groupId})       // Will cause an extra page load; seems OK otherwise, though
    }

    $scope.$watch(function () {
      return locationService.getSelectedGroupId();
    }, function (groupId, oldGroupId) {
      if (!groupId) {
        //Ignore initial update
        return;
      }

      if ($state.params.groupId !== groupId) {
        $state.go('snapshot', {groupId: groupId})
      } else {
        $scope.locationInfo.newlocation = false;
        loadSnapshot(groupId);
      }
    }, true);
  });
